import React from 'react';
import PropTypes from 'prop-types';
import ProductRating from '@tcp/core/src/components/features/browse/ProductDetail/molecules/ProductRating/ProductRating';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import PriceCurrency from '@tcp/core/src/components/common/molecules/PriceCurrency';
import { getProductListToPath } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import style from '../styles/FeaturedproductTile.style';
import withStyles from '../../../hoc/withStyles';
import {
  getIsTabletWebSearch,
  getIsMobileWebSearch,
} from '../../SearchBar/WebSearchBar/helpers/webSearchUiHelper';

const FeaturedProductTile = (props) => {
  const {
    className,
    imageUrl,
    originalPrice,
    offerPrice,
    offerText,
    productName,
    ratings,
    reviewCount,
    pdpUrl,
    redirectToProductUrl,
    onCloseClick,
    primaryBrand,
    searchEnhancementRedesign,
    searchHeader,
  } = props;
  const damImageConfig = ['t_plp_img_m,f_auto', 't_plp_img_t,f_auto', 't_plp_img_d,f_auto'];
  let pdpToPath = getProductListToPath(pdpUrl);
  pdpToPath = `${pdpToPath}&imageSearch=${true}&searchType=${searchHeader}`;

  return (
    <div className={`${className} product-tile-layout`}>
      <ClickTracker
        clickData={{
          customEvents: ['event100', 'event20'],
          var22: 'internal search',
          pageSearchText: productName,
          pageSearchType: 'image search',
          listingCount: 4,
          searchType: `${searchHeader}` || '',
        }}
        as={Anchor}
        className="featured-product-link"
        to={pdpToPath}
        asPath={pdpUrl}
        onClick={(e) => {
          e.preventDefault();
          if (getIsTabletWebSearch() || getIsMobileWebSearch()) {
            onCloseClick();
          }
          redirectToProductUrl();
        }}
      >
        <DamImage
          className={`product-tile-img ${searchEnhancementRedesign ? 'search-redesign' : ''}`}
          imgConfigs={damImageConfig}
          imgData={{
            alt: productName,
            url: imageUrl?.replace('.mp4', '.jpg'),
          }}
          itemBrand={primaryBrand || null}
          isProductImage
        />
        <BodyCopy
          fontFamily="secondary"
          fontSize="fs12"
          fontWeight="extrabold"
          color="red.500"
          className={`tile-discount-price ${searchEnhancementRedesign ? 'redesign' : ''}`}
        >
          <PriceCurrency price={offerPrice} />
        </BodyCopy>

        {originalPrice && originalPrice !== offerPrice ? (
          <div className="tile-discount">
            <BodyCopy
              component="span"
              color="gray.700"
              fontFamily="secondary"
              fontWeight="normal"
              fontSize="fs10"
              className={`original-price ${searchEnhancementRedesign ? 'redesign' : ''}`}
            >
              <PriceCurrency price={originalPrice} />
            </BodyCopy>

            <BodyCopy
              component="span"
              color="red.400"
              fontFamily="secondary"
              fontWeight="normal"
              fontSize="fs10"
              className={`percentage_all_wrapped_normal_tab ${
                searchEnhancementRedesign ? 'redesign' : ''
              }`}
            >
              {offerText}
            </BodyCopy>
          </div>
        ) : null}

        <div className="product-title-container">
          <span inheritedStyles="product-title-content">
            <BodyCopy
              fontSize="fs10"
              fontFamily="secondary"
              className={`product-name multiline-ellipsis`}
            >
              {productName}
            </BodyCopy>
          </span>
        </div>

        <div className="ratings-container">
          {ratings > 0 ? <ProductRating ratings={ratings} reviews={reviewCount} /> : null}
        </div>
      </ClickTracker>
    </div>
  );
};
FeaturedProductTile.propTypes = {
  className: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  originalPrice: PropTypes.number.isRequired,
  offerPrice: PropTypes.number.isRequired,
  offerText: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  pdpUrl: PropTypes.string.isRequired,
  toPath: PropTypes.string.isRequired,
  ratings: PropTypes.string.isRequired,
  reviewCount: PropTypes.string.isRequired,
  primaryBrand: PropTypes.string,
  redirectToProductUrl: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};
FeaturedProductTile.defaultProps = {
  primaryBrand: null,
};
export default withStyles(FeaturedProductTile, style);
export { FeaturedProductTile as FeaturedProductTileVanilla };
